const configurationStyle = {
	actionContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	phantomFooter: {
		display: 'block',
		padding: '20px',
		height: '91px',
		width: '100%',
	},
	footer: {
		backgroundColor: '#F8F8F8',
		borderTop: '1px solid #E7E7E7',
		textAlign: 'center',
		padding: '26px',
		position: 'fixed',
		left: '0',
		bottom: '0',
		height: '91px',
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	saveButton: {
		marginTop: '0px',
		marginRight: '5px',
		marginBottom: '0px',
		marginLeft: '5px',
		width: '143px',
		height: '43px',
		fontSize: '12px',
	},
	subTitle: {
		margin: '30px 0 0',
		color: '#a5a5a5',
		fontWeight: 'bolder',
	},
	loadingIndicator: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
};

export default configurationStyle;